import { useState } from 'react';
import { getLiveOAuthClient } from './auth/live-session.js';
import { getBootstrapMessage } from './status.js';
import './styles.css';

export function LiveApp() {
  const [signingIn, setSigningIn] = useState(false);
  const [error, setError] = useState<string>();

  async function handleSignIn(): Promise<void> {
    if (signingIn) return;
    setSigningIn(true);
    setError(undefined);
    try {
      const client = await getLiveOAuthClient();
      const authorizationUrl = await client.beginAuthorization();
      globalThis.location.assign(authorizationUrl);
    } catch (reason: unknown) {
      setSigningIn(false);
      setError(reason instanceof Error ? reason.message : 'Runtime configuration failed.');
    }
  }

  return (
    <main className="shell">
      <section className="panel" aria-labelledby="title">
        <p className="eyebrow">InfraHub · Live foundation</p>
        <h1 id="title">InfraHub</h1>
        <p>{getBootstrapMessage()}</p>
        {error !== undefined ? <p role="alert">{error}</p> : null}
        <button type="button" disabled={signingIn} onClick={() => void handleSignIn()}>
          {signingIn ? 'Opening sign in…' : 'Sign in'}
        </button>
        <dl>
          <div>
            <dt>Frontend</dt>
            <dd>React + TypeScript</dd>
          </div>
          <div>
            <dt>Backend</dt>
            <dd>AWS Lambda · Node.js 24</dd>
          </div>
          <div>
            <dt>Infrastructure</dt>
            <dd>AWS CDK v2 · CloudFormation</dd>
          </div>
        </dl>
      </section>
    </main>
  );
}
